/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SourcingSearchFreelancerType } from './';
import {
    SourcingSearchFreelancerTypeFromJSON,
    SourcingSearchFreelancerTypeFromJSONTyped,
    SourcingSearchFreelancerTypeToJSON,
} from './';
import type { SourcingSearchMatchingHighlight } from './';
import {
    SourcingSearchMatchingHighlightFromJSON,
    SourcingSearchMatchingHighlightFromJSONTyped,
    SourcingSearchMatchingHighlightToJSON,
} from './';
import type { SourcingSearchPhoto } from './';
import {
    SourcingSearchPhotoFromJSON,
    SourcingSearchPhotoFromJSONTyped,
    SourcingSearchPhotoToJSON,
} from './';
import type { SourcingSearchRegisteredFreelancer } from './';
import {
    SourcingSearchRegisteredFreelancerFromJSON,
    SourcingSearchRegisteredFreelancerFromJSONTyped,
    SourcingSearchRegisteredFreelancerToJSON,
} from './';
import type { SourcingSearchUnregisteredFreelancer } from './';
import {
    SourcingSearchUnregisteredFreelancerFromJSON,
    SourcingSearchUnregisteredFreelancerFromJSONTyped,
    SourcingSearchUnregisteredFreelancerToJSON,
} from './';

/**
 * 
 * @export
 * @interface SourcingSearchFreelancer
 */
export interface SourcingSearchFreelancer {
    /**
     * 
     * @type {SourcingSearchFreelancerType}
     * @memberof SourcingSearchFreelancer
     */
    type: SourcingSearchFreelancerType;
    /**
     * 
     * @type {SourcingSearchPhoto}
     * @memberof SourcingSearchFreelancer
     */
    photo?: SourcingSearchPhoto;
    /**
     * 
     * @type {Array<SourcingSearchMatchingHighlight>}
     * @memberof SourcingSearchFreelancer
     */
    matchingHighlights?: Array<SourcingSearchMatchingHighlight>;
}

/**
 * Check if a given object implements the SourcingSearchFreelancer interface.
 */
export function instanceOfSourcingSearchFreelancer(value: object): value is SourcingSearchFreelancer {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function SourcingSearchFreelancerFromJSON(json: any): SourcingSearchFreelancer {
    return SourcingSearchFreelancerFromJSONTyped(json, false);
}

export function SourcingSearchFreelancerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFreelancer {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'REGISTERED') {
            return SourcingSearchRegisteredFreelancerFromJSONTyped(json, true);
        }
        if (json['type'] === 'UNREGISTERED') {
            return SourcingSearchUnregisteredFreelancerFromJSONTyped(json, true);
        }
    }
    return {
        
        'type': SourcingSearchFreelancerTypeFromJSON(json['type']),
        'photo': json['photo'] == null ? undefined : SourcingSearchPhotoFromJSON(json['photo']),
        'matchingHighlights': json['matchingHighlights'] == null ? undefined : ((json['matchingHighlights'] as Array<any>).map(SourcingSearchMatchingHighlightFromJSON)),
    };
}

export function SourcingSearchFreelancerToJSON(value?: SourcingSearchFreelancer | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'REGISTERED') {
            return SourcingSearchRegisteredFreelancerToJSON(value as SourcingSearchRegisteredFreelancer);
        }
        if (value.type === 'UNREGISTERED') {
            return SourcingSearchUnregisteredFreelancerToJSON(value as SourcingSearchUnregisteredFreelancer);
        }
    }
    return {
        
        'type': SourcingSearchFreelancerTypeToJSON(value['type']),
        'photo': SourcingSearchPhotoToJSON(value['photo']),
        'matchingHighlights': value['matchingHighlights'] == null ? undefined : ((value['matchingHighlights'] as Array<any>).map((v) => SourcingSearchMatchingHighlightToJSON(v))),
    };
}

